// extracted by mini-css-extract-plugin
module.exports = {"image":"img_image__JI00N","fullWidth":"img_fullWidth__sTnN4","wrapper":"img_wrapper__2MCpV","hoverEffectZoom":"img_hoverEffectZoom__sJq5k","hoverHandle":"img_hoverHandle__9NgDT"};